import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiTransactionService } from '@services/api-transaction.service';
import { SharedService } from '@services/shared.service';
import { TransactionModel } from '@shared/models/TransactionModel';

@Component({
  selector: 'app-delete-transaction',
  templateUrl: './delete-transaction.component.html',
  styleUrls: ['./delete-transaction.component.scss']
})
export class DeleteTransactionComponent {

  @Input() transaction: TransactionModel;

  constructor(
    public router: Router,
    public sharedService: SharedService,
    public apiTransactionService: ApiTransactionService,
    public modalService: NgbModal
  ) {
  }


  onViewMessage(messageModal: any) {

    this.modalService.open(messageModal, {
      backdrop: true, // Permitir interacciones con el fondo
      keyboard: false, // Deshabilitar el cierre con la tecla Esc
      scrollable: true,
      centered: true, windowClass: 'modal-full'
    });

  }

  onDelete() {

    this.modalService.dismissAll();
    this.sharedService.setLoading(true);
    //delete transaction
    this.apiTransactionService.deleteTransaction(this.transaction).then(() => {

      this.sharedService.setLoading(false);
      this.sharedService.showSuccessAlert(null, "Givi eliminado con éxito").then(_x => window.location.reload());
    },
      (err) => {

        this.sharedService.setLoading(false);
        let errMsg = `Error al eliminar el Givi`;
        this.sharedService.showErrorAlert(null, errMsg).then(_x => window.location.reload());
      });
  }

}
